export class TimeZoneModel {
    public timeZoneCode:string;
    public timeZoneName:string;
}